import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";
import { Alert, Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import batchServiceV3 from "services/batchServiceV3";

import { ButtonsContent, StyledBox, Text } from "../../style";
import { ClassificationContainer } from "./style";

export const InitialPage = ({
  classification,
  handleChangeClassification,
  batchId,
  handleClose
}) => {
  const { addPopup } = usePopup();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await batchServiceV3.receiptAction(batchId, "register_classification", {
        classification
      });
      handleClose();
    } catch (err) {
      addPopup({ type: "error", title: "Erro ao registrar classificação" });
    } finally {
      setIsLoading(false);
    }
  };

  const validate = () => {
    if (!classification) {
      return addPopup({
        type: "error",
        title: "Informações obrigatórias",
        description: "Selecione uma classificação"
      });
    }
    handleConfirm();
  };

  return (
    <>
      <StyledBox>
        <Alert isSuccess title="Peso aprovado" />
        <Text>A maior parte do lote está em qual classificação?</Text>
        <ClassificationContainer>
          <FormControl component="fieldset">
            <RadioGroup
              value={classification}
              onChange={handleChangeClassification}
            >
              <FormControlLabel
                value="A"
                control={<Radio />}
                label="Classe A"
                style={{ backgroundColor: "#F4F4F4", borderRadius: "0.5rem" }}
              />

              <FormControlLabel
                value="B"
                control={<Radio />}
                label="Classe B"
                style={{ backgroundColor: "#F4F4F4", borderRadius: "0.5rem" }}
              />
              <FormControlLabel
                value="C"
                control={<Radio />}
                label="Classe C"
                style={{ backgroundColor: "#F4F4F4", borderRadius: "0.5rem" }}
              />
            </RadioGroup>
          </FormControl>
        </ClassificationContainer>
      </StyledBox>
      <ButtonsContent>
        <Box display="flex" justifyContent="flex-end">
          <Button
            style={{ width: "50%", marginLeft: "auto" }}
            variant="contained"
            onClick={validate}
            isLoading={isLoading}
          >
            Concluir
          </Button>
        </Box>
      </ButtonsContent>
    </>
  );
};
